import {dateFormat} from "../../../services/misc.functions";
import React from "react";
import {Link} from "react-router-dom";
import paths from "../../../paths";
import newBadge from "../../../assets/img/new-badge.png"
import {isMobile} from "../../../App";
import blackHorse from "../../../assets/img/siyahat.png";

export function BettingTypeOptions({
    params,
    hippodrome,
    hippodromes = [],
    bettingType,
    bettingSubType,
    availableBettingTypes = [],
    availableBettingSubTypes = [],
    isMobileSlipOpen,
    selectBettingType,
    selectBettingSubType,
    onChangeHippodrome,
}: any) {
    if (isMobileSlipOpen) {
        return <></>;
    }

    const hippodromeSelect = (
        <>
            <label className="hidden-sm">HİPODROMLAR</label>
            <select
                onChange={(e: any) => onChangeHippodrome(e.target.value)}
                value={hippodrome.keyword + hippodrome._id}
            >
                {hippodromes.filter((h: any) => h.wager_details.length > 0).map((h: any) => (
                    <option key={`hippodrome-${h._id}`} value={h.keyword + h._id}>
                        {h.hippodrome}{" "}
                        {new Date(h.date).getDate() <= new Date().getDate() ? (
                            <>{h.nextRun && ` - ${h.nextRun.no}. Koşu ${h.nextRun.time}`}</>
                        ) : (
                            <> - ({dateFormat(h.date)})</>
                        )}
                    </option>
                ))}
            </select>
        </>
    );

    const bettingTypeSelect = bettingType && bettingType.id !== 0 && (
        <>
            <label className="hidden-sm">BAHİS TÜRÜ</label>
            <select onChange={(e: any) => selectBettingType(e.target.value)} value={bettingType.id}>
                {availableBettingTypes.map((el: any) => (
                    <option key={`bettingType-${el.id}`} value={el.id}>{el.name}</option>
                ))}
            </select>
        </>
    );

    const bettingSubTypeSelect = bettingSubType && bettingType && bettingType.id !== 0 && (
        <>
            <label className="hidden-sm">KOŞU</label>
            <select onChange={(e: any) => selectBettingSubType(e.target.value)} value={bettingSubType.id}>
                {availableBettingSubTypes.map((el: any) => (
                    <option key={`bettingSubType-${el.id}`} value={el.id}>{el.label}</option>
                ))}
            </select>
        </>
    );

    const bettingUrl = `${paths.betting.url}/${hippodrome.keyword.toLowerCase()}${hippodrome._id}`;

    return (
        <div className="bettingtype-options p-3 mb-3">
            {isMobile ? (
                <>
                    <div className={"row"}>
                        <div className={"col-4 pe-0 ps-0"}>{hippodromeSelect}</div>
                        {bettingTypeSelect && <div className="col-4 pe-0 ps-2">{bettingTypeSelect}</div>}
                        {bettingSubTypeSelect && <div className="col-4 pe-0 ps-2">{bettingSubTypeSelect}</div>}
                    </div>
                    <div className="row mt-2">
                        <div className="col-4 pe-0 ps-0">
                            <Link to={bettingUrl} className={`btn btn-muhtemeller ${!params.subpage ? "active" : ""}`}>
                                BAHİS YAP
                            </Link>
                        </div>
                        <div className="col-4 pe-0 ps-2">
                            <Link
                                to={`${bettingUrl}/muhtemeller`}
                                className={`btn btn-muhtemeller ${params.subpage === "muhtemeller" ? "active" : ""}`}
                            >
                                MUHTEMEL/AGF
                            </Link>
                        </div>
                        <div className="col-4 pe-0 ps-2">
                            <Link to={`${paths.fobBetting.url}`} className={`btn btn-tab-agf fob-switch active`}>
                                <img alt={"iconFather"} src={blackHorse} className={"me-1"} height={30}/>
                                SABİT ORANLI BÜLTEN
                            </Link>
                        </div>
                    </div>
                </>
            ) : (
                <div className="row">
                    <div className="col-6">
                        <div className="row">
                            <div className="col-12 mb-2 mb-sm-0 col-lg-6 p-0 px-sm-2">{hippodromeSelect}</div>
                            <div className="col-6 col-lg-3 p-0 pe-1 pe-sm-2">{bettingTypeSelect}</div>
                            <div className="col-6 col-lg-3 p-0 ps-1 pe-sm-2">{bettingSubTypeSelect}</div>
                        </div>
                    </div>
                    <div className="col-lg-6 p-0 px-sm-2 pt-2 pt-sm-4">
                        <div className="row">
                            <div className={`col-4 col-lg-3 pe-1 ps-1`}>
                                <Link to={bettingUrl} className={`btn btn-muhtemeller ${!params.subpage ? "active" : ""}`}>
                                    BAHİS YAP
                                </Link>
                            </div>
                            <div className={`col-4 col-lg-3 pe-1 ps-1`}>
                                <Link
                                    to={`${bettingUrl}/muhtemeller`}
                                    className={`btn btn-muhtemeller ${params.subpage === "muhtemeller" ? "active" : ""}`}
                                >
                                    MUHTEMELLER/AGF
                                </Link>
                            </div>
                            <div className={`col-3 col-lg-3 ps-1 `}>
                                <Link
                                    to={`${bettingUrl}/agf`}
                                    className={`btn btn-agf ${params.subpage === "agf" ? "active" : ""}`}
                                >
                                    AGF
                                </Link>
                            </div>
                            <div className="col-3 col-lg-3 ps-1 position-relative">
                                <div className={"new-badge"}>
                                    <img src={newBadge}/>
                                </div>
                                <Link
                                    className={`btn btn-agf`}
                                    style={{fontSize: "12px", lineHeight: "1.2"}}
                                    to={`${paths.fobBetting.url}`}
                                >
                                    <img alt={"iconFather"} src={blackHorse} className={"me-1"} height={30}/>
                                    SABİT ORANLI BÜLTEN
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
